<div class="p-6">
    <div class="flex items-center justify-between">
        <h2 class="text-xl font-semibold flex items-center">
            Scan Image
            <mat-spinner *ngIf="isLoading" class="ml-2" diameter="20"></mat-spinner>
        </h2>
        <button mat-icon-button [mat-dialog-close]="undefined">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="mt-6">
        <div class="upload-container cursor-pointer" (click)="fileInput.click()" (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

            <input #fileInput type="file" hidden accept="image/*" (change)="onFileSelected($event)">

            <div *ngIf="!imagePreview" class="drag-drop-area">
                <mat-icon class="text-4xl">cloud_upload</mat-icon>
                <p class="mt-2">Drag and drop an image here or click to upload</p>
                <p class="text-sm text-secondary">Supported formats: PNG, JPG, JPEG</p>
            </div>

            <img *ngIf="imagePreview" [src]="imagePreview" alt="Preview" class="image-preview">
        </div>

        <div *ngIf="parsedData || isLoading" class="mt-6">
            <!-- <h3 class="text-lg font-medium mb-4">Parsed Contact Information</h3> -->

            <!-- Loading spinner -->
            <!-- <div *ngIf="isLoading" class="flex justify-center items-center py-4">
                <mat-spinner diameter="40"></mat-spinner>
                <span class="ml-3">Parsing business card...</span>
            </div> -->

            <!-- Parsed data content -->
            <!-- <div *ngIf="!isLoading && parsedData" class="grid grid-cols-2 gap-2">
                <div *ngFor="let item of parsedDataEntries" class="parsed-data-item py-1">
                    <span class="font-medium">{{item.key}}:</span>
                    <span>{{item.value}}</span>
                </div>
            </div> -->

            <div class="flex justify-end mt-6">
                <button mat-button [mat-dialog-close]="undefined">Cancel</button>
                <button mat-flat-button color="primary" class="ml-2" (click)="closeDialog()" [disabled]="!parsedData">
                    Insert
                </button>
            </div>
        </div>
    </div>
</div>